﻿export const clientVersion: string = "2.0.2411.3";